import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'

/**
 * `optionalDependencies` are installed and importable at runtime, so they count
 * as present here exactly as they do for `update`. Omitting them made `generate`
 * offer to install a package the project already declares.
 */
export function hasDeclaredPackage(
  pkg: ProjectPackageJson | null,
  name: string,
  options: { runtimeOnly?: boolean } = {}
): boolean {
  if (!pkg) return false
  if (Object.hasOwn(pkg.dependencies ?? {}, name)) return true
  if (Object.hasOwn(pkg.optionalDependencies ?? {}, name)) return true
  return options.runtimeOnly ? false : Object.hasOwn(pkg.devDependencies ?? {}, name)
}
